/**
 * Pagina 404.
 *
 * No es un callejon sin salida: ofrece volver a la portada y escribir por
 * WhatsApp, porque quien llega aca casi siempre venia siguiendo un enlace viejo
 * a un producto que existe con otro nombre.
 */
import { Link } from 'react-router-dom';

import { Icono } from '../componentes/comunes/Icono';
import { Seo } from '../seo/Seo';
import { rutas } from '../utilidades/rutas';
import { registrarClicWhatsapp } from '../servicios/metricas.servicio';
import { whatsappGeneral } from '../utilidades/whatsapp';

export function NoEncontrado() {
  return (
    <>
      <Seo
        titulo="Página no encontrada"
        descripcion="La página que buscas no existe o cambió de dirección."
        ruta="/404"
        sinIndexar
      />

      <div className="contenedor pagina">
        <div className="vacio">
          <span className="vacio-icono">
            <Icono nombre="lupaVacia" />
          </span>
          <h1>No encontramos esta página</h1>
          <p>
            El enlace puede estar viejo o el producto pudo cambiar de nombre. Busca en el catálogo
            o escríbenos y te ayudamos a encontrarlo.
          </p>
          <p className="acc">
            <Link className="btn btn-primario" to={rutas.inicio()}>
              Volver al inicio
            </Link>{' '}
            <a
              className="btn btn-wa"
              href={whatsappGeneral()}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => registrarClicWhatsapp({ origen: 'no_encontrado' })}
            >
              <Icono nombre="wa" />
              Escribir por WhatsApp
            </a>
          </p>
        </div>
      </div>
    </>
  );
}
